(function (ws) {
    'use strict';

    ws.views.stackedBarChart = ws.views.baseWidget.extend({
        GTM_EVENT_CATEGORY: 'store_dashboard',
        GTM_EVENT_ACTION: 'click_order_statistics_CTA',

        events: {
            'click .cta-link a': 'trackCtaLinkOnBar'
        },

        /**
         * Initializes the component.
         */
        initialize() {
            ws.views.baseWidget.prototype.initialize.call(this);

            this.data = this.$('.meta').data('json');
            this.$legend = this.$('.legend');
            this.$stackedBarGraph = this.$('.stacked-bar-graph');
            this.render();
        },

        /**
         * Renders the component based on the json data provided by the backend.
         * Normalizes each data point for conversion into a CSS height for each bar.
         */
        render() {
            this.grandTotal = this.calculateGrandTotal();
            var strGraphContent = '';
            var strLegendContent = '';

            for (var i = 0; i < this.data.length; i++) {
                var height = (this.data[i].orderTotal * 100) / this.grandTotal;
                strGraphContent += '<div class="' + this.data[i].statusCode + '" style="height:' + height + '%" >&nbsp;</div>';
                strLegendContent += ('<li class="' + this.data[i].statusCode + '"><strong>' + this.data[i].formattedValue + '</strong><small>' + this.data[i].status + '</small></li>');
            }

            this.$stackedBarGraph.html(strGraphContent);
            this.$legend.html(strLegendContent);
        },

        /**
         * Determines the grand total of all orders to be displayed on the chart.
         * @returns {number} calculated grand total
         */
        calculateGrandTotal() {
            return _.reduce(this.data, function(memo, obj) {
                return memo + obj.orderTotal;
            }, 0);
        },

        /**
         * Sends data from a link to Google Analytics;
         *
         * @param {Event} e
         */
        trackCtaLinkOnBar: function(e) {
            // Stop the link from navigating away
            e.preventDefault();

            // Send tracking data to Google Analytics
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION, 'cta_button');

            // Send tracking data to adobe Analytics
            dataLayerAA.event = {};
            dataLayerAA.event.action = 'view recent orders';
            dataLayerAA.event.label = e.target.text.toLowerCase();
            _satellite.track('event:dashboard');
            window.location.href = $(e.currentTarget).attr('href');
        }

    });
})(westcon);
